const UserProfile = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.2222 14.0001C27.2222 21.3025 21.3024 27.2223 14 27.2223C6.69756 27.2223 0.777771 21.3025 0.777771 14.0001C0.777771 6.69762 6.69756 0.777832 14 0.777832C21.3024 0.777832 27.2222 6.69762 27.2222 14.0001ZM13.9997 15.4692C16.8396 15.4692 19.1417 13.167 19.1417 10.3272C19.1417 7.48738 16.8396 5.18524 13.9997 5.18524C11.1599 5.18524 8.85775 7.48738 8.85775 10.3272C8.85775 13.167 11.1599 15.4692 13.9997 15.4692ZM13.9997 15.4692C17.5036 15.4692 20.5668 17.3563 22.2282 20.1697C20.352 22.668 17.3646 24.284 13.9997 24.284C10.6349 24.284 7.64744 22.668 5.77125 20.1697C7.43269 17.3563 10.4958 15.4692 13.9997 15.4692Z"
      />
    </svg>
  );
};

export default UserProfile;
